import { AtlassianApi } from 'osep-generator-service-client-v1';
import { useApiConfig } from './useApiConfig';

export const useAtlassianDisconnect = () => {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const disconnectFromAtlassian = async () => {
    const apiConfig = await getApiConfig();
    const atlassianApi = new AtlassianApi(apiConfig, undefined, axiosInstance);
    atlassianApi.removeAtlassianAccess();
  };
  return { disconnectFromAtlassian };
};
